import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Layout from "../../components/Layout";

const DeletedHaribhakt = () => {
  const apiURL = process.env.REACT_APP_API_URL;
  const [admins, setAdmins] = useState([]);
  const [haribhakt, setHaribhakt] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SuperAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
    // eslint-disable-next-line
  }, []);

  const fetchRecords = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${apiURL}/User/Get`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data?.data || [];
      // Filter only admin records that are visible
      const haribhaktRecords = data.filter((item) => !item.isVisible);

      setHaribhakt(haribhaktRecords);
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (rowId) => {
    const confirmed = window.confirm(
      "Are you sure you want to retrive this record?"
    );
    if (!confirmed) return;
    try {
      const response = await axios.delete(`${apiURL}/User/Delete?id=${rowId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      toast.success("Haribhakt retrived successfully!");
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      fetchRecords();
    }
  };

  const columns = [
    {
      name: "No",
      selector: (row, index) =>
        `${(currentPage - 1) * rowsPerPage + index + 1}`,
      sortable: true,
      width: "65px",
      center: "true",
    },
    {
      name: "Photo",
      selector: (row) => row.imagePath,
      cell: (row) => (
        <img
          src={row.imageBase64 ? row.imageBase64 : "dist/img/user.png"}
          alt="img"
          style={{ width: "75px", height: "auto" }}
        />
      ),
      width: "100px",
      center: "true",
    },
    {
      name: "Name",
      selector: (row) => row.firstName + " " + row.lastName + " " + row.surName,
      sortable: true,
    },
    {
      name: "Mobile Number",
      selector: (row) => {
        const contactNumbers = [row.contactNo, row.contactNo1, row.contactNo2];
        const contactInfo =
          contactNumbers.filter(Boolean).join("<br />") ||
          "No contact available";
        return <div dangerouslySetInnerHTML={{ __html: contactInfo }} />;
      },
      // width: "150px",
    },
    {
      name: "Address",
      selector: (row) => row.houseNo + ", " + row.street + ", " + row.address,
    },
    {
      name: "Actions",
      width: "120px",
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-secondary btn-sm mr-1"
            onClick={() => handleDelete(row.id)}
          >
            <i className="fas fa-eye-slash"></i>
          </button>
        </div>
      ),
      center: "true",
    },
  ];
  return (
    <>
      <Layout ac7="active">
        <section className="content-header pb-0">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h5>Admin</h5>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/manage">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Deleted Haribhakts</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <div className="d-flex justify-content-between">
                      <div className="bd-highlight">
                        <input
                          className="form-control"
                          type="search"
                          placeholder="Search"
                          title="Search within table"
                        />
                      </div>
                      <div className="bd-highlight"></div>
                    </div>
                  </div>
                  <div className="card-body text-center">
                    {loading ? (
                      <>
                        {" "}
                        <span
                          className="spinner-border spinner-border-sm "
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </>
                    ) : (
                      <DataTable
                        columns={columns}
                        data={haribhakt}
                        pagination
                        highlightOnHover
                        pointerOnHover
                        responsive
                        className="custom-table"
                        onChangePage={(page) => setCurrentPage(page)}
                        onChangeRowsPerPage={(newPerPage) => {
                          setRowsPerPage(newPerPage);
                          setCurrentPage(1);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ToastContainer position="top-center" style={{ width: "auto" }} />
      </Layout>
    </>
  );
};

export default DeletedHaribhakt
